import React from 'react'

import withSession from '@/housefolios-components/Session/withSession'
import { connect } from 'react-redux'
import { Box, Typography } from '@mui/material'
import { sidebarFooterSx, poweredByLogoSx } from '@/layout-blueprints/chromeComponentSx'
import {
  setSidebarToggleMobile,
  setSidebarToggle,
} from '../../reducers/ThemeOptions'

const SidebarFooter = (props) => {
  return (
    <>
      <Box sx={sidebarFooterSx} data-hf="sidebar-footer">
        <Typography color="primary">Powered by</Typography>
        <Box
          component="img"
          alt="Housefolios"
          src={'/images/NewLogoBlue.png'}
          sx={poweredByLogoSx}
        />
        {/* <ul>
          <li>
            <Tooltip arrow placement="top" title="Analytics Dashboard">
              <Button
                variant="text">
                <ListAltTwoToneIcon />
              </Button>
            </Tooltip>
          </li>
          <li>
            <Tooltip arrow placement="top" title="Crypto Components">
              <Button
                variant="text">
                <MarkunreadTwoToneIcon />
              </Button>
            </Tooltip>
          </li>
          <li>
            <Tooltip arrow placement="top" title="Buttons">
              <Button
                variant="text">
                <LinkedCameraTwoToneIcon />
              </Button>
            </Tooltip>
          </li>
        </ul> */}
      </Box>
    </>
  )
}

const mapStateToProps = (state) => ({
  sidebarUserbox: state.DeprecatedThemeOptions.sidebarUserbox,
  sidebarToggle: state.DeprecatedThemeOptions.sidebarToggle,
  sidebarToggleMobile:
    state.DeprecatedThemeOptions.sidebarToggleMobile,
})

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggle: (enable) => dispatch(setSidebarToggle(enable)),
  setSidebarToggleMobile: (enable) =>
    dispatch(setSidebarToggleMobile(enable)),
})

export default withSession(
  connect(mapStateToProps, mapDispatchToProps)(SidebarFooter),
)
